import { premiumBuildingsPrices } from "@/config/constants";
import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class PremiumGoldMineBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.PREMIUM_GOLD_MINE;

	public static readonly baseGemsPrice =
		premiumBuildingsPrices[this.frameName];
}

export default PremiumGoldMineBuildingTileEntity;
